'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function populateCoverageData(context, data) {
  context.updateProp('application.associated_policy', data.associated_policy);
  context.updateProp('application.additional_data.country_of_origin', data.additional_data.country_of_origin);
  context.updateProp('application.additional_data.existing_policy', data.additional_data.existing_policy);
  (0, _commonFunctions.populateEligibility)(context, data);
}

function populateApplicantsAdditionalData(context, data) {
  var studentNumber = 'applicant[0].additional_data.student_number';
  if ((0, _url2.default)('renewal_id')) {
    context.updateProp(studentNumber, data.applicants[0].additional_data.student_number);
  } else {
    context.updateProp(studentNumber, data.additional_data.applicants[0].additional_data.student_number);
  }
  context.updateProp('application.additional_data.staff_member', data.additional_data.staff_member || '');
}

function populateProductSpecificData(context, data) {
  populateCoverageData(context, data);
  populateApplicantsAdditionalData(context, data);
}

exports.default = function (context) {
  (0, _commonFunctions.populateQuoteData)(context, populateProductSpecificData);
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/student/quote.js
// module id = 1762
// module chunks = 0